import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'saveButton', 'connectNewButton'];

  inputTargets: HTMLInputElement[];

  saveButtonTarget: HTMLButtonElement;

  connectNewButtonTarget: HTMLButtonElement;

  toggleRow(e: Event) {
    e.preventDefault();
    const el = e.currentTarget as HTMLElement;
    const inputTarget = this.inputTargets.find(t => t.dataset.externalAccountId === el.dataset.externalAccountId);

    el.classList.toggle('is-selected');
    if (inputTarget) {
      inputTarget.checked = !inputTarget.checked;
    }

    this.updateButtons();
  }

  updateButtons() {
    if (this.inputTargets.some(t => t.checked)) {
      this.saveButtonTarget.disabled = false;
      this.connectNewButtonTarget.value = 'Save and connect new';
    } else {
      this.saveButtonTarget.disabled = true;
      this.connectNewButtonTarget.value = 'Connect new account';
    }
  }
}
